module.exports = new __parcel__URL__("software-development.a5df06ef.svg").toString();